export default __webpack_public_path__ + "static/media/navbar-icon-top-sellers.5b43951a.svg";